<header class="header" *ngIf="!customerValidation">
  <ng-container *ngIf="flow === FLOWS.ONBOARDING && step !== 2">
    <div class="header__onboarding">
      <h1>
        ¡Estás a un paso de disfrutar<br />
        los beneficios de {{ CONST.BBVA_PRODUCT_NAME }}!
      </h1>
    </div>
  </ng-container>
  <ng-container *ngIf="flow === FLOWS.SCORE">
    <div class="header__score">
      <h1>¡Hola {{ name }}!</h1>
      <p>
        {{
          customerStatus !== CUSTOMER_STATUS.UNAVAILABLE_SCORE
            ? 'Cupo aprobado para tus compras'
            : 'Tu préstamo fue rechazado'
        }}
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="flow === FLOWS.INSTALLMENTS">
    <div class="header__payment">
      <h1>Tu compra</h1>
      <p>Plan de pagos y aceptación de tu Contrato de Crédito Rotativo</p>
    </div>
  </ng-container>
</header>
